import classes from './Textarea.module.scss';
import { forwardRef } from 'react';

function Textarea(props: TextareaProps, ref: any) {
	function onChange(value: string) {
		props.onChange && props.onChange(value);
	}
	const classNames = [classes.Textarea];
	if (props.disabled) classNames.push(classes.disabled);
	return (
		<textarea
			placeholder={props.placeholder}
			className={classNames.join(' ')}
			rows={props.rows}
			ref={ref}
			required={props.required}
			disabled={props.disabled ? true : false}
			onChange={(e) => onChange(e.target.value)}
		/>
	);
}

export default forwardRef(Textarea);

interface TextareaProps {
	placeholder?: string;
	rows?: number;
	onChange?: Function;
	required?: boolean;
	disabled?: boolean;
	className?: string;
}
